<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'订单下拉权限'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">


            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="用户usercode">
							    <el-input v-model="q.usercode"></el-input>
							</el-form-item>
							<el-form-item label="角色名">
							    <el-input v-model="q.name"></el-input>
							</el-form-item>
							<el-form-item label="一级选">
							    <el-input v-model="q.numinonename"></el-input>
							</el-form-item>
							<el-form-item label="二级选">
							    <el-input v-model="q.numintwoname"></el-input>
							</el-form-item>
						</div>
                        <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn" @click="kaishixinzeng=true">修改</el-button>
                        </div>
                    </el-form>
                </div>
            </div>



            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        :span-method="objectSpanMethod"
                        stripe
						border
                        style="width: 100%"
                >

                    <el-table-column
                            prop="usercode"
                            label="相关用户编码"
                            width="130">
                    </el-table-column>

                    <el-table-column
                            prop="name"
                            label="角色名"
							:show-overflow-tooltip="true"
                            width="180">
                    </el-table-column>

                    <el-table-column
                            prop="numinonename"
                            label="一级可选"
							:show-overflow-tooltip="true"
                            width="300">
                    </el-table-column>
                    <el-table-column
                            prop="numintwoname"
                            label="二级可选"
							:show-overflow-tooltip="true"
                            >
                    </el-table-column>

                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                    <pagination :page="q" @query="query" />
<!--                    <el-button type="primary">导出</el-button>-->
                </div>
            </div>
        </div>




        <el-dialog :visible.sync="kaishixinzeng" :show-close="true" :close-on-click-modal="false" class="h-dialog2">
			<div class="h-dialogImg">
			    <div class="h-disTable">
			        <div class="h-tableCell">
			            <h1>角色级别选择</h1>
			            <p>Role Level Selection</p>
			        </div>
			    </div>
			</div>
            <!--表单-->
            <div class="h-formLine ljjjiaose">
                <el-form ref="form" :model="f"
                         :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm">


                    <el-form-item label="角色" prop="jiaosecode" :rules="[
								  { required: true, message: '请输入角色code名称', trigger: 'blur'},
								]" class="h-elformWrap-1">

                        <el-select v-model="f.jiaosecode" placeholder="请选择" filterable @change="xuanjiaose" >
                            <el-option v-for="item in jiaoselist" :key="item.id"
                                       :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>

                    </el-form-item>

                    <el-form-item label="一级选" prop="numinone"  class="h-elformWrap-2">

                        <brselect clearable category="xiaoshou_quyu" :v="f.numinone"
                                  v-model="f.numinone" @change="yijixuan"></brselect>

                        <!-- <el-input v-model="f.numinonenamelist"></el-input> -->
						<div style="display: flex;flex-shrink: 0;align-items: center;margin-top: 0.1rem;flex-wrap: wrap;">
							<div style="margin-left: 0.1rem;">
								{{f.numinonenamelist}}
							</div>
						</div>
						
						<div style="display: flex;justify-content: center;align-items: center;margin-top: 0.1rem;">
							<el-button class="h-btn h-formBtn" @click="qingkong1">清空</el-button>
						</div>

                    </el-form-item>

                    <el-form-item label="二级选" prop="numintwo"  class="h-elformWrap-2">

                        <brselect clearable category="xiaoshou_quyu_nwx" :v="f.numintwo"
                                  v-model="f.numintwo" @change="erjixuan" :showdes="true"></brselect>

<!--                        <el-select v-model="f.numintwo" placeholder="请选择" filterable @change="erjixuan" >-->
<!--                            <el-option v-for="item in erjilistxuan" :key="item.code"-->
<!--                                       :label="`[${item.des}]${item.name}`" :value="item.code">-->
<!--                            </el-option>-->
<!--                        </el-select>-->


<!-- 
                        <el-input v-model="f.numintwonamelist"></el-input>

                        <el-button class="h-btn h-formBtn" @click="qingkong2">清空</el-button> -->
						<div style="display: flex;flex-shrink: 0;align-items: center;margin-top: 0.1rem;flex-wrap: wrap;">
							<div style="margin-left: 0.1rem;">
								{{f.numintwonamelist}}
							</div>
						</div>
						
						<div style="display: flex;justify-content: center;align-items: center;margin-top: 0.1rem;">
							<el-button class="h-btn h-formBtn" @click="qingkong2">清空</el-button>
						</div>

                    </el-form-item>
                </el-form>
            </div>
			<div style="display: flex;justify-content: center;align-items: center;">
				<el-button class="h-btn h-formBtn" @click="tijiaoxiugai">新增修改</el-button>
			</div>


        </el-dialog>








    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        components: {},
        data() {
            return {

                erjilistxuan:[],

                numinonelist:[],

                numintwolist:[],

                jiaoselist:[],

                kaishixinzeng:false,

                orderTypeList:[],
                nwxchildren:[],

                //游标集
                spanArr:[],

                //游标定位
                position:'',

                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f:{

                    jiaosecode:null, // 角色code
                    numinone:null, // 一级选
                    numintwo:null, // 二级选

                    numinonelist:null,//一级集
                    numintwolist:null,//二级集

                    numinonenamelist:null,//一级集名
                    numintwonamelist:null,//二级集名

                },
                //table列表
                tableData: [],
                //操作标志
                optflag:'save',
            }
        },
        created() {

            this.huoqukexuanjiaose();

            this.orderTypeList=this.$store.getters.dictlist("xiaoshou_quyu");
            this.nwxchildren=this.$store.getters.dictlist("xiaoshou_quyu_nwx");

            for(var c in this.nwxchildren){

                this.erjilistxuan.push({

                    code:this.nwxchildren[c].code,
                    des:this.nwxchildren[c].des,
                    name:this.nwxchildren[c].name,

                })

            }


            console.log(this.orderTypeList,'this.orderTypeList')
            console.log(this.nwxchildren,'this.nwxchildren')
            this.query();
        },

        watch:{

            kaishixinzeng(val) {

                if (val == false) {

                    this.quanqingf();

                }

            },

        },
        methods: {

            qingkong1(){

                this.$msg.confirm("确认清空？",()=>{

                    this.f.numinonelist = null;
                    this.f.numinonenamelist = null;

                })

            },

            qingkong2(){

                this.$msg.confirm("确认清空？",()=>{

                    this.f.numintwolist = null;
                    this.f.numintwonamelist = null;

                })

            },



            //选角色
            xuanjiaose(q){

                this.f.numinone='';
                this.f.numintwo='';
                this.f.numinonelist='';
                this.f.numintwolist='';
                this.f.numinonenamelist='';
                this.f.numintwonamelist='';

                console.log(q,'qqssss')

                var id = {

                    id:q,

                }

                ss.chanpin.selectByjiaosecode(id).then(rd=>{

                    if(rd.obj!= null){

                        console.log(rd.obj,"asdwc")

                        this.f.numinonelist = rd.obj.numinone;

                        this.f.numintwolist = rd.obj.numintwo;

                        this.f.numinonenamelist = rd.obj.numinonename;

                        this.f.numintwonamelist = rd.obj.numintwoname;

                        this.f.jiaosecode = rd.obj.jiaosecode;


                    }

                })

            },

            yijixuan(q){

                console.log(q,'qqq')

                console.log(this.f.numinonenamelist,'this.f.numinonenamelist')

                if(!this.panduanyiyou(this.f.numinonelist,q.code)){
                    this.f.numinonelist = (this.f.numinonelist?(this.f.numinonelist+"_"):"")+q.code;
                    this.f.numinonenamelist = (this.f.numinonenamelist?(this.f.numinonenamelist+"_"):"")+q.des+","+q.name;
                }


            },

            erjixuan(q){

                console.log(q,'qqqqq')

                if(!this.panduanyiyou(this.f.numintwolist,q.code)){
                    this.f.numintwolist = (this.f.numintwolist?(this.f.numintwolist+"_"):"")+q.code;
                    this.f.numintwonamelist = (this.f.numintwonamelist?(this.f.numintwonamelist+"_"):"")+q.des+","+q.name;
                }


            },



            panduanyiyou(q,a){

                var yes = false;

                if(q&&a&&q.split("_").length>0){

                    if(q.split("_").length>1){

                        for(var d in q.split("_")){

                            if(q.split("_")[d]==a){
                                yes = true;
                            }

                        }

                    }else{

                       if(q==a){

                           yes = true;

                       }

                    }

                }

                return yes;

            },

            quanqingf(){

                this.f = {


                    jiaosecode:null, // 角色code
                    numinone:null, // 一级选
                    numintwo:null, // 二级选

                    numinonelist:null,//一级集
                    numintwolist:null,//二级集

                    numinonenamelist:null,//一级集名
                    numintwonamelist:null,//二级集名

                };

            },



            tijiaoxiugai(){

                console.log(this.f,'this.f')

                if(this.f.numinonelist==null||this.f.numinonelist==''||this.f.numintwolist==null||this.f.numintwolist==''||this.f.numinonenamelist==null||this.f.numinonenamelist==''||this.f.numintwonamelist==null||this.f.numintwonamelist==''){

                    this.$msg.msge("请选择完整信息")

                }else{

                    ss.chanpin.saveorupdatein(this.f).then(rd=>{

                        console.log(rd,'rd.aaa')

                        if(rd.f==true){

                            this.$msg.msgs("提交成功")
                            this.kaishixinzeng = false;

                            this.quanqingf();

                            this.handleFilter();


                        }

                    })

                }


            },


            //获取角色信息
            huoqukexuanjiaose(){

                ss.chanpin.bscrolelist().then(rd=>{

                    console.log(rd,'rd')

                    this.jiaoselist = rd;

                })

            },


            //记录游标的方法
            getSpanArr() {

                //游标集，每个元素的下标对应当前页table的每一行的行号，每个元素的数字对应这一行条件相同的共重复了几行
                this.spanArr = [];

                //遍历当前表元素
                this.tableData.forEach((item, index) => {

                    //当第一行时
                    if (index === 0) {

                        //默认先放第一行是1次
                        this.spanArr.push(1);

                        //记录当前重复行的位置
                        this.position = 0;

                        //其他行
                    } else {

                        //如果该行上的usercode与上一行上的usercode重复
                        if (this.tableData[index].usercode === this.tableData[index - 1].usercode) {

                            //从游标集中取到记录重复行的那行的重复数字，自增1(又重复一次)
                            this.spanArr[this.position] += 1;

                            //因为这次重复了，所以放入0记录作为这行实际上应该被合并掉
                            this.spanArr.push(0);

                            //若不重复
                        } else {

                            //继续向游标集放入一个1作为本行没有重复的独立一次记录
                            this.spanArr.push(1);

                            //记录重复行位置的游标移动到本行位置
                            this.position = index;

                        }
                    }
                })
            },


            //合并单元行方法
            objectSpanMethod({row, column, rowIndex, columnIndex}) {


                //需要合并单元行的是哪几列
                if (column.label=="用户usercode") {

                    //从游标集取到对应行下标位置的行重复记录数字，作为需要被合并多少行的rowspan数(该行跨了几行)
                    const _row = this.spanArr[rowIndex];

                    //该行跨了几列
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

            },


            query() {

                ss.chanpin.quanxuanQuyuselectPage(this.q).then(rd=>{

                    this.q.total = rd.total;
                    this.tableData = rd.records;

                    console.log(rd.records,'rd.records')

                    this.getSpanArr();

                })
            },



            handleFilter() {

                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.q.total = 0;

                this.query();
            },
        }
    }
</script>
<style>
	.ljjjiaose .h-dialogForm.h-formbLine .h-elformWrap-2{
		padding-right: 0.4rem;
	}
	.ljjjiaose .h-dialogForm.h-formbLine .h-elformWrap-1{
		padding-right: 0.4rem;
	}
	.ljjjiaose .h-dialogForm.h-formbLine .el-form-item__label{
		width: 25%;
	}
	.ljjjiaose .h-dialogForm.h-formbLine .el-form-item__content{
		width: 75%;
	}
	.ljjjiaose .h-dialogForm.h-formbLine .h-elformWrap-1 .el-form-item__label{
		width: 12%;
	}
	.ljjjiaose .h-dialogForm.h-formbLine .h-elformWrap-1 .el-form-item__content{
		width: 88%;
	}
</style>